import {
  extractScriptRegistryActionIds,
  readRootFormOnLoadScript,
  shouldRunRootFormOnLoadOnClientBeforeBuild,
} from '@/common/utils/formRootOnLoad'

function readJsResultStates(pageData: Record<string, unknown>): unknown[] {
  const states = (pageData.jsResult as { states?: unknown[] } | undefined)?.states
  return Array.isArray(states) ? states : []
}

/** Open response не содержит visibility states для layout (onLoad setVisible не replay'ится). */
export function openResponseLacksLayoutVisibilityStates(pageData: Record<string, unknown>): boolean {
  const states = readJsResultStates(pageData)
  if (states.length === 0) {
    return true
  }
  return !states.some((raw) => {
    if (!raw || typeof raw !== 'object') return false
    const state = raw as Record<string, unknown>
    if (state.is_visible === undefined) return false
    const level = String(state.element_level ?? state.element_type ?? '').trim().toUpperCase()
    return level === 'ACTION' || level === 'PANEL' || level === 'ELEMENT'
  })
}

/**
 * onLoad вызывает setVisible("action", …), но в jsResult.states нет ACTION is_visible.
 */
export function openResponseLacksActionVisibilityStates(
  pageData: Record<string, unknown>,
  onLoadScript?: string | null,
): boolean {
  const script = onLoadScript ?? readRootFormOnLoadScript(pageData.form)
  const actionIds = extractScriptRegistryActionIds(script ?? '')
  if (actionIds.length === 0) {
    return false
  }

  const coveredActionIds = new Set<number>()
  for (const raw of readJsResultStates(pageData)) {
    if (!raw || typeof raw !== 'object') continue
    const state = raw as Record<string, unknown>
    if (String(state.element_level ?? state.element_type ?? '').trim().toUpperCase() !== 'ACTION') {
      continue
    }
    if (state.is_visible === undefined) continue
    const id = Number(state.element_id)
    if (Number.isFinite(id)) {
      coveredActionIds.add(id)
    }
  }

  return actionIds.some((id) => !coveredActionIds.has(id))
}

/** Startup dialog с server onLoad, но без полного visibility в open — догнать executeScript. */
export function shouldRunStartupDialogServerOnLoadCatchUp(
  pageData: Record<string, unknown>,
): boolean {
  const form = pageData.form
  if (!form || typeof form !== 'object') {
    return false
  }
  if (shouldRunRootFormOnLoadOnClientBeforeBuild(form)) {
    return false
  }
  const script = readRootFormOnLoadScript(form)
  if (!script?.trim()) {
    return false
  }
  return (
    openResponseLacksLayoutVisibilityStates(pageData) ||
    openResponseLacksActionVisibilityStates(pageData, script)
  )
}
